import { render, staticRenderFns } from "./SortingCenter.vue?vue&type=template&id=cae4004a&scoped=true"
import script from "./SortingCenter.vue?vue&type=script&lang=js"
export * from "./SortingCenter.vue?vue&type=script&lang=js"
import style0 from "./SortingCenter.vue?vue&type=style&index=0&id=cae4004a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cae4004a",
  null
  
)

export default component.exports